import { useDocumentHeadTags } from 'hooks/use-document-head-tags'
type Props = {
  title?: string
  link?: {
    href: string
    rel: string
  }
  style?: [
    {
      type: string
      cssText: string | null | undefined
    },
  ]
}
export default function DocumentHeadTags({ title, link, style }: Props): null {
  const setDocumentHeadTags = useDocumentHeadTags({
    title: title ? title : 'DISCO',
    style: style,
    link: link,
  })
  return null
}
